var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "kalender",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 11.5385V4.48718H1.33333V11.5385H10.6667ZM10.6667 1.28205C11.4 1.28205 12 1.85897 12 2.5641V11.5385C12 12.2436 11.4 12.8205 10.6667 12.8205H1.33333C0.6 12.8205 0 12.2436 0 11.5385V2.5641C0 1.85897 0.6 1.28205 1.33333 1.28205H2V0.666667C2 0.298477 2.29848 0 2.66667 0C3.03486 0 3.33333 0.298477 3.33333 0.666667V1.28205H8.66667V0.666667C8.66667 0.298477 8.96514 0 9.33333 0C9.70152 0 10 0.298477 10 0.666667V1.28205H10.6667ZM9.33333 5.76923V7.05128H8V5.76923H9.33333ZM6.66667 5.76923V7.05128H5.33333V5.76923H6.66667ZM4 5.76923V7.05128H2.66667V5.76923H4Z",
    fill: "#B2B2B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ab6a8e74.svg";
export { ForwardRef as ReactComponent };